import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Lightning, Crown } from "@phosphor-icons/react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const HERO = "https://static.prod-images.emergentagent.com/jobs/062e260e-b0f9-432f-a759-5890d554bb91/images/896c8d32ebe1a63eb3cb5fe3cf3f22d8c607128b8cbc109565c0770de9cfdfcc.jpeg";

export default function Bandanas() {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then(({ data }) => setAll(data)).finally(() => setLoading(false));
  }, []);

  const bandanas = useMemo(
    () => all.filter((p) => p.category === "accessories" && (p.tags || []).includes("bandana")),
    [all]
  );
  const grails = bandanas.filter((p) => p.exclusivity);
  const core = bandanas.filter((p) => !p.exclusivity);

  return (
    <div data-testid="bandanas-page">
      {/* Hero */}
      <div className="relative h-[52vh] min-h-[380px] w-full overflow-hidden">
        <img src={HERO} alt="The Bandana Vault" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-black/40" />
        <div className="relative z-10 h-full max-w-7xl mx-auto px-5 sm:px-8 flex flex-col justify-end pb-12">
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="overline text-primary mb-3">The Bandana Vault</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }} className="font-display text-4xl sm:text-5xl lg:text-6xl max-w-2xl leading-[1.05]">
            Loud, loyal, <span className="neon-text">limited</span>.
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.12 }} className="text-muted-foreground mt-4 max-w-xl">
            Premium neon streetwear bandanas. The $50 core runs of 300 — plus a locked vault of $100 grails, 1-of-10 and 1-of-30. When they're gone, they're gone.
          </motion.p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[4/5] rounded-xl bg-muted animate-pulse" />)}
          </div>
        ) : (
          <>
            {grails.length > 0 && (
              <section className="mb-16" data-testid="bandana-grails">
                <div className="flex items-center gap-2 mb-6">
                  <Crown weight="fill" size={18} className="text-amber-400" />
                  <h2 className="font-display text-2xl sm:text-3xl">The Vault — Exclusive Grails</h2>
                </div>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="bandana-grail-grid">
                  {grails.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
                </div>
              </section>
            )}
            <section data-testid="bandana-core">
              <div className="flex items-center gap-2 mb-6">
                <Lightning weight="fill" size={18} className="text-primary" />
                <h2 className="font-display text-2xl sm:text-3xl">The Core — $50 Drop</h2>
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="bandana-core-grid">
                {core.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
}
